import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { useRadio } from "@website/ui/radio/radio.hook";
import styles from "@website/ui/radio/radio.module.scss";
import { RadioPropertiesType } from "@website/ui/radio/radio.types";
import { FC } from "react";
export const Radio: FC<RadioPropertiesType> = properties => {
  const $ = _c(24);
  const {
    inputProps
  } = useRadio(properties);
  let checked;
  let properties_;
  if ($[0] !== inputProps) {
    ({
      checked,
      ...properties_
    } = inputProps);
    $[0] = inputProps;
    $[1] = checked;
    $[2] = properties_;
  } else {
    checked = $[1];
    properties_ = $[2];
  }
  const {
    className,
    labelClassName,
    color,
    disabled,
    label,
    icon
  } = properties;
  const t0 = `${styles.radio} ${disabled ? styles.disabled : ""} ${className ?? ""}`;
  const t1 = checked ?? false;
  let t2;
  if ($[3] !== properties_ || $[4] !== t1) {
    t2 = <input checked={t1} {...properties_} className={styles.input} />;
    $[3] = properties_;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon className={styles["un-checked-icon"]} name="radio_button_unchecked" variant="outlined" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${styles["checked-icon"]} ${styles[color || "primary"]}`;
  let t5;
  if ($[7] !== t4) {
    t5 = <MaterialIcon className={t4} name="radio_button_checked" variant="outlined" />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `${styles.ripple} ${styles[color || "primary"]}`;
  let t7;
  if ($[9] !== t6) {
    t7 = <div className={t6} />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t7) {
    t8 = <div className={styles.box}>{t3}{t5}{t7}</div>;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = `${styles.label} ${labelClassName}`;
  const t10 = !label;
  let t11;
  if ($[14] !== label || $[15] !== t10 || $[16] !== t9) {
    t11 = <span className={t9} hidden={t10}>{label}</span>;
    $[14] = label;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== icon || $[19] !== t0 || $[20] !== t11 || $[21] !== t2 || $[22] !== t8) {
    t12 = <label className={t0}>{t2}{t8}{t11}{icon}</label>;
    $[18] = icon;
    $[19] = t0;
    $[20] = t11;
    $[21] = t2;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};